import CompanyHeader from '../components/CompanyHeader'
import CompanySideMenu from "../components/CompanySideMenu";
import CompanyDashboard from './company_home/CompanyDashboard';
import Copyright from "components/Copyright";
const CompanyHome = () => {
    return (
        <>
            <CompanyHeader/>
            <div className="mt-6 px-6 flex gap-6 relative">
                <CompanySideMenu />
                <CompanyDashboard />
            </div>
            <Copyright view="company" />
        </>
  );
};
export default CompanyHome;